import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-line-semantics-time-series-topic',
  templateUrl: './line-semantics-time-series-topic.component.html',
  styleUrl: './line-semantics-time-series-topic.component.scss',
})
export class LineSemanticsTimeSeriesTopicComponent {
  isLoading = true;

  label: any = {
    show: true,
    position: 'inside',
    formatter: (params) =>
      params.value >= 5 ? parseInt(params.value) + '%' : '',
    fontWeight: 'bold',
    color: '#fff',
  };

  options: echarts.EChartsOption = {
    grid: { left: 20, right: 30, top: 40, bottom: 80 },
    stack: 'total',
    yAxis: {
      max: 100,
      axisLabel: {
        formatter: '{value}%', // append percentage sign to labels
      },
    },
    series: [
      {
        type: 'bar',
        stack: 'total',
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
    ],
  };

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.semanticsTimeSeriesTopic$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('semanticsTimeSeriesTopic');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getSemanticsTimeSeriesTopic().subscribe();
  }

  get series() {
    return this.analyticsService.semanticsTimeSeriesTopic$.value?.series;
  }

  get labels() {
    return this.analyticsService.semanticsTimeSeriesTopic$.value?.labels;
  }
}
